var app = angular.module('directives.cardSecure');

app.directive('secure3d', [
    function () {
        return {
            restrict: 'E',
            template: require('../templates/secure3d.html'),
            replace: true,
            scope: {
            },
            link: function (scope, el) {
                var METHOD_FRAME_ID = 'secure3dMethodFrame';

                scope.secure3d = {
                    show: false,
                    method: false
                };

                function hidePopup() {
                    scope.secure3d.show = false;
                    scope.secure3d.method = false;
                }

                function removeMethodFrame() {
                    var frame = document.getElementById(METHOD_FRAME_ID);
                    if (frame && frame.parentNode) {
                        frame.parentNode.removeChild(frame);
                    }
                }

                // The 3DS Method (device fingerprinting) frame. Appended to body,
                // outside the ng-show wrappers, so it stays rendered (1x1,
                // transparent) instead of display:none - ACS fingerprint scripts
                // misreport layout metrics inside display:none frames.
                function getMethodFrame() {
                    var frame = document.getElementById(METHOD_FRAME_ID);

                    if (!frame) {
                        frame = document.createElement('iframe');
                        frame.setAttribute('id', METHOD_FRAME_ID);
                        frame.setAttribute('name', '3dsMethodFrame');
                        frame.setAttribute('title', '3D Secure');
                        frame.setAttribute('aria-hidden', 'true');
                        frame.setAttribute('tabindex', '-1');
                        frame.style.cssText = 'position:absolute;top:0;left:-9999px;width:1px;height:1px;border:0;opacity:0;pointer-events:none;';
                        document.body.appendChild(frame);
                    }

                    return frame;
                }

                // Build, submit and drop a throwaway POST form. The target frame
                // keeps loading after the form is removed, and nothing is left in
                // the DOM to collide with the next payment attempt.
                function postToFrame(targetName, secureData) {
                    var form = document.createElement('form');
                    form.setAttribute('method', 'post');
                    form.setAttribute('target', targetName);
                    form.setAttribute('action', secureData.ascUrl);
                    form.style.display = 'none';

                    var formParams = JSON.parse(secureData.postParams);
                    formParams['termUrl'] = secureData.termUrl;

                    for (var key in formParams) {
                        if (formParams.hasOwnProperty(key)) {
                            var hiddenField = document.createElement('input');
                            hiddenField.setAttribute('type', 'hidden');
                            hiddenField.setAttribute('name', key);
                            if (typeof formParams[key] === 'object') {
                                hiddenField.setAttribute('value', JSON.stringify(formParams[key]));
                            }
                            else {
                                hiddenField.setAttribute('value', formParams[key]);
                            }
                            form.appendChild(hiddenField);
                        }
                    }

                    document.body.appendChild(form);
                    form.submit();
                    form.parentNode.removeChild(form);
                }

                // Visible challenge: 3ds1 and 3ds2_frame. Deduplication of the
                // repeated 5s polling broadcasts lives in user-payment
                // (pay.secureCard) - every event received here does a real POST.
                scope.$on('start3dSecure', function (e, secureData) {
                    scope.secure3d.method = false;
                    scope.secure3d.show = true;
                    removeMethodFrame();

                    if (secureData.postParams) {
                        postToFrame('3dSecureFrame', secureData);
                    } else {
                        angular.element(el).find('#paReq').val(secureData['paReq']);
                        angular.element(el).find('#md').val(secureData['md']);
                        angular.element(el).find('#termUrl').val(secureData['termUrl']);
                        angular.element(el).find('#3dForm').attr('action', secureData['ascUrl']).submit();
                    }
                });

                // Invisible 3DS Method step: 3ds2_hidden. The ACS page stays in
                // the offscreen frame, the user sees only the progress loader.
                // Deduplicated in user-payment via pay.methodStarted.
                scope.$on('start3dsMethod', function (e, secureData) {
                    scope.secure3d.method = true;
                    getMethodFrame();
                    postToFrame('3dsMethodFrame', secureData);
                });

                // rootScope broadcasts reach this isolate scope, and scope
                // listeners die with the scope - unlike the previous
                // $rootScope.$on, which leaked one listener per page visit.
                scope.$on('stop3dSecure', function () {
                    hidePopup();
                    removeMethodFrame();
                });

                scope.$on('$stateChangeStart', function () {
                    hidePopup();
                    removeMethodFrame();
                });

                scope.$on('$destroy', removeMethodFrame);
            }
        };
    }]
);

module.exports = app;



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/cardSecure/directives/secure3d.directive.js
 ** module id = 143
 ** module chunks = 1
 **/